import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExpandableComponent, LimitedViewElementId, LimitedViewElement, createLimitedViewElementControl } from '../../model/uiControl'
import { closeCheckout } from '../'
import { PURGE } from 'redux-persist'

export interface UiControlState {
  expandedComponentId: ExpandableComponent | null
  limitedViewElementControl: Record<LimitedViewElementId, LimitedViewElement>
}

export const uiControlInitialState: UiControlState = {
  expandedComponentId: ExpandableComponent.SHIPPING_OPTION,
  limitedViewElementControl: createLimitedViewElementControl(),
}

const uiControlSlice = createSlice({
  name: 'uiControl',
  initialState: uiControlInitialState,
  extraReducers: (builder) => {
    builder.addCase(closeCheckout, () => uiControlInitialState).addCase(PURGE, () => uiControlInitialState)
  },
  reducers: {
    setExpandedComponent(state: UiControlState, action: PayloadAction<ExpandableComponent | null>) {
      state.expandedComponentId = action.payload
    },
    addElementView(state: UiControlState, action: PayloadAction<{ id: LimitedViewElementId; count?: number }>) {
      const { id, count = 1 } = action.payload
      const element = state.limitedViewElementControl[id]
      if (!element) return

      element.view = Math.min(element.view + count, element.maxView)
    },
    resetElementView(state: UiControlState, action: PayloadAction<LimitedViewElementId>) {
      const id = action.payload
      const element = state.limitedViewElementControl[id]
      if (!element) return

      element.view = 0
    },
  },
})

export const { setExpandedComponent, addElementView, resetElementView } = uiControlSlice.actions

export default uiControlSlice.reducer
